import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KennethMustDie} from "../KennethMustDie";
import {KMDGameMode} from "../server/KMDGameMode";
import {gsap} from "gsap";

export class KMDBackgroundElements extends PIXI.Container implements StageLayer {

    private _backgroundMain: PIXI.spine.Spine;
    private _backgroundFS: PIXI.spine.Spine;
    private _backgroundSFS: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "KMDBackgroundElements";
        this.init();
    }

    public setMode(mode: string): void {
        KennethMustDie.reelFrame.toggleReelFrame(mode);
        KennethMustDie.logo.updateYAsPerMode(mode);

        // #540
        KennethMustDie.possibleWays.onGameModeChanged(mode);

        this._backgroundFS.y = 360;
        if (mode === KMDGameMode.FREESPIN || mode === KMDGameMode.FREESPIN_AVALANCHE) {
            this.swapBackgroundTo(this._backgroundFS);
        } else if (mode === KMDGameMode.FREESPIN_COOL || mode === KMDGameMode.FREESPIN_COOL_AVALANCHE) {
            this.swapBackgroundTo(this._backgroundFS);

            if (KennethMustDie.model.isRestore) {
                this._backgroundFS.y = -100;
            }

        } else if (mode === KMDGameMode.FREESPIN_SUPER || mode === KMDGameMode.FREESPIN_SUPER_AVALANCHE) {
            this.swapBackgroundTo(this._backgroundSFS);
        } else {
            this.swapBackgroundTo(this._backgroundMain);
        }
    }

    // #281
    public transitionForCFS(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.to(this._backgroundFS, {
            duration: duration,
            y: -100,
            ease: "none"
        });

        return tl;
    }

    public shake(): void {
        (this.children[0] as PIXI.spine.Spine).state.setAnimation(0, "shaking", true);
    }

    public stopShake(): void {
        (this.children[0] as PIXI.spine.Spine).state.clearTracks();
        (this.children[0] as PIXI.spine.Spine).state.setAnimation(0, "animation", true);
    }

    public pump(duration: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline(),
            item: PIXI.DisplayObject = this.children[0];

        tl.to(item.scale, {
            duration: duration,
            x: 1.05,
            y: 1.05
        });
        tl.to(item.scale, {
            duration: duration,
            x: 1,
            y: 1
        });

        return tl;
    }

    private init(): void {
        this._backgroundMain = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("mgBgAnimation"));
        this._backgroundMain.position.set(379, 486);

        this._backgroundFS = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("fsBgAnimation"));
        this._backgroundFS.position.set(358, 360);

        this._backgroundSFS = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("sfsBgAnimation"));
        this._backgroundSFS.position.set(363, 430);

        this.addChild(this._backgroundMain);
    }

    private swapBackgroundTo(newBackground: PIXI.spine.Spine): void {
        this.addChildAt(newBackground, 0);

        newBackground.visible = true;
        newBackground.updateTransform();
        newBackground.state.setAnimation(0, "animation", true);

        if (this.children.length > 1) {
            const otherBg: PIXI.spine.Spine = (this.children[1] as PIXI.spine.Spine);
            otherBg.state.clearTracks();
            this.removeChild(otherBg);
        }
    }
}